// extracted by mini-css-extract-plugin
module.exports = {"container":"FocusPageBenefits_container__agAEO","heading":"FocusPageBenefits_heading__rRPAx","tilesContainer":"FocusPageBenefits_tilesContainer___jqK9"};